module.exports = __webpack_public_path__ + "static/media/logo-web.67558f37.png";